function _classCallCheck(a, n) {
    if (!(a instanceof n))
        throw new TypeError('Cannot call a class as a function');
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports['default'] = module.exports;